import gql from 'graphql-tag';

export const ACTIVE_SKV_DEVICE = gql`
  mutation ActivateSkvDevice(
    $corporateId: String!
    $deviceId: String!
    $deviceName: String!
    $street: String!
    $city: String!
    $zip: String!
    $legalName: String!
  ) {
    activateSkvDevice(
      corporateId: $corporateId
      deviceId: $deviceId
      deviceName: $deviceName
      street: $street
      city: $city
      zip: $zip
      legalName: $legalName
    ) {
      error
      message
      success
      controlUnitSerial
      productionNumber
    }
  }
`;

export const CREATE_POS_DEVICE = gql`
  mutation CreatePOSDevice(
    $name: String!
    $venueId: ID!
    $companyId: ID!
    $lastSeen: DateTime!
    $isForDeviceSettings: Boolean
  ) {
    createPOSDevice(
      name: $name
      venueId: $venueId
      companyId: $companyId
      lastSeen: $lastSeen
      isForDeviceSettings: $isForDeviceSettings
    ) {
      id
    }
  }
`;
